import { IconProps } from "Icons/types";

export const GoogleIcon = ({
  width = 16,
  height = 16,
  fill = "none",
}: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1943_1222)">
      <path
        d="M15.844 8.18417C15.844 7.64035 15.8 7.09359 15.7059 6.55859H8.16003V9.63925H12.4812C12.3019 10.6328 11.7257 11.5117 10.8821 12.0703V14.0692H13.4601C14.9739 12.6758 15.844 10.6181 15.844 8.18417Z"
        fill="#4285F4"
      />
      <path
        d="M8.15999 16.0007C10.3176 16.0007 12.1372 15.2923 13.4629 14.0694L10.885 12.0705C10.1677 12.5585 9.24174 12.8348 8.16293 12.8348C6.07584 12.8348 4.30623 11.4268 3.67128 9.53369H1.01099V11.5943C2.36906 14.2958 5.13518 16.0007 8.15999 16.0007Z"
        fill="#34A853"
      />
      <path
        d="M3.66827 9.53331C3.33316 8.53974 3.33316 7.46387 3.66827 6.4703V4.40967H1.01091C-0.123755 6.67019 -0.123755 9.33342 1.01091 11.5939L3.66827 9.53331Z"
        fill="#FBBC04"
      />
      <path
        d="M8.15999 3.16644C9.30053 3.1488 10.4029 3.57798 11.2289 4.36578L13.5129 2.08174C12.0667 0.72367 10.1471 -0.0229773 8.15999 0.000539111C5.13518 0.000539111 2.36906 1.70548 1.01099 4.40987L3.66834 6.4705C4.30035 4.57449 6.0729 3.16644 8.15999 3.16644Z"
        fill="#EA4335"
      />
    </g>
    <defs>
      <clipPath id="clip0_1943_1222">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
